import { commonFetch } from "./fetch";

// 获取产品列表
function getProductList(
  data: ProductListParams
): Promise<ProductListData> {
  return commonFetch(
    "/crm-mdm/v1/product/product/findPageProductVoByConditions",
    true,
    data
  );
}

// 获取产品详情
function getProductDetail(
  data: { id: string }
): Promise<ProductInfo> {
  return commonFetch(
    "/crm-mdm/v1/product/product/findDetailById",
    true,
    data
  );
}

const productApi = {
  getProductList,
  getProductDetail,
}

export default productApi;
